const skrzyniaBiegow = { t: 'Skrzynia biegów', name: 'skrzynia-biegow', hint: { url: '/gearbox' }}
export default skrzyniaBiegow